import React from 'react';
import { ObjectWrapper } from './styles/Common.styles';
import {
  ProgressBarWrapper,
  ProgressBarTrack,
  ProgressBarFill,
  ProgressBarLabel
} from './styles/ProgressBar.styles';

const ProgressBarControl = ({ control }) => {
  const percent = control.maxValue > 0 ? (control.value / control.maxValue) * 100 : 0;
  const labelText = control.labelText.replace('%1%', `${Math.round(percent)}%`);

  return (
    <ObjectWrapper>
      <ProgressBarWrapper>
        <ProgressBarTrack styleProps={control.attributes}>
          <ProgressBarFill percent={percent} styleProps={control.attributes} />
        </ProgressBarTrack>
        {control.showLabel && (
          <ProgressBarLabel styleProps={control.attributes}>
            {labelText}
          </ProgressBarLabel>
        )}
      </ProgressBarWrapper>
    </ObjectWrapper>
  );
};

export default ProgressBarControl;